<template>
    <div class="inventory-system">
        <!-- 左侧边栏 -->
        <aside class="sidebar">
            
            <div class="store-list" ref="storeListContainer">
                <div 
                    v-for="store in stores" 
                    :key="store.id"
                    @click="selectStore(store)"
                    class="store-item"
                >
                    <div class="store-info">
                        <div 
                            class="store-type-dot"
                            :class="store.type === '' ? 'direct' : 'franchise'"
                        ></div>
                        <span class="store-name">{{ store.name }}</span>
                    </div>
                    <!-- <span class="store-amount">
                        ¥{{ formatMoney(store.amount) }}
                    </span> -->
                </div>
            </div>
            
            <!-- <div class="sidebar-footer">
                <div class="stat-item">
                    <div class="stat-label">总计店铺</div>
                    <div class="stat-value">xxx</div>
                </div>
                <div class="stat-item text-right">
                    <div class="stat-label">总库存额</div>
                    <div class="stat-value total">¥cccc</div>
                </div>
            </div> -->
        </aside>

        <!-- 右侧内容区 -->
        <main class="main-content">
            <!-- 顶部标题和筛选区 -->
            <header class="content-header">
                <div class="header-top">
                    <div class="title-section">
                        <h1> {{ currentStoreName }}</h1>
                        <span class="store-badge" >
                            购物车总价：￥{{ cartPrice }}，
                            购物车款数：{{ cartNum }}
                        </span>
                    </div>
                </div>
            </header>

            <!-- 表格区域 -->
            <div class="table-container">
                <div class="table-wrapper">
                    <el-table
                        :data="products"
                        stripe
                        style="width: 100%">
                        <el-table-column
                        prop="barcode"
                        label="SKU"
                        width="180">
                        </el-table-column>
                        <el-table-column
                        prop="name"
                        label="产品名称"
                        width="230">
                        </el-table-column>

                        <el-table-column
                        prop="quantity"
                        label="数量">

                        </el-table-column>
                        <el-table-column
                        prop="price"
                        label="单价">
                        </el-table-column>


                        <el-table-column
                        prop="subtotal"
                        label="总价">
                        </el-table-column>
                    </el-table>
                </div>
                
                <!-- 分页 -->
                <div class="pagination">
                    <!-- {{ pages.page }},
                    {{ pages.size }},
                    {{ pages.total }} -->
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pages.page"
                    :page-size="pages.size"
                    layout="total, prev, pager, next, jumper"
                    :total="pages.total">
                    </el-pagination>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import indexjs from "./js/index";
export default indexjs;
</script>

<style scoped lang="scss">
@import "./css/index";
</style>